<template>
  <div>
    <h2 class="vcr-page__header">{{ i18n.t('/Vcr/Contact Details/Title') }}</h2>

    <div class="vcr-quote-contact-details__sections">
      <div v-if="hasCustomer" class="vcr-quote-contact-details__section">
        <h3 class="vcr-page__sub-header">
          {{ i18n.t('/Vcr/Contact Details/Customer/Title') }}
        </h3>

        <dl>
          <dt>{{ i18n.t('/Vcr/Contact Details/Customer/Name Label') }}</dt>
          <dd>
            {{ customer.CustomerInitials }} {{ customer.CustomerMiddleName }}
            {{ customer.CustomerFamilyName }}
          </dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/Customer/Email Address Label') }}
          </dt>
          <dd data-qa="vcr-customer-email">{{ customer.CustomerEmail }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/Customer/Phone Number Label') }}
          </dt>
          <dd>{{ customer.CustomerPhone }}</dd>

          <dt>{{ i18n.t('/Vcr/Contact Details/Customer/Address Label') }}</dt>
          <dd>{{ customer.CustomerAddress }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/Customer/Postal Code Label') }}
          </dt>
          <dd>{{ customer.CustomerZipCode }}</dd>

          <dt>{{ i18n.t('/Vcr/Contact Details/Customer/City Label') }}</dt>
          <dd>{{ customer.CustomerCity }}</dd>
        </dl>
      </div>

      <div v-if="hasEmployee" class="vcr-quote-contact-details__section">
        <h3 class="vcr-page__sub-header">
          {{ i18n.t('/Vcr/Contact Details/Employee/Title') }}
        </h3>

        <dl>
          <dt>{{ i18n.t('/Vcr/Contact Details/Employee/Name Label') }}</dt>
          <dd>{{ employee.EmployeeName }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/Employee/Email Address Label') }}
          </dt>
          <dd>{{ employee.EmployeeEmail }}</dd>
        </dl>
      </div>

      <div v-if="hasCustomerCompany" class="vcr-quote-contact-details__section">
        <h3 class="vcr-page__sub-header">{{ i18n.t('') }}Gegevens organisatie</h3>

        <dl>
          <dt>
            {{ i18n.t('/Vcr/Contact Details/Customer Company/Name Label') }}
          </dt>
          <dd>{{ customerCompany.CustomerCompanyName }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/Customer Company/Magic Number Label') }}
          </dt>
          <dd>{{ customerCompany.CustomerCompanyMagicNumber }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/Customer Company/Po Id Label') }}
          </dt>
          <dd>{{ customerCompany.CustomerCompanyPoId }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/Customer Company/Chamber Of Commerce Label') }}
          </dt>
          <dd>{{ customerCompany.CustomerCompanyChamberOfCommerceNumber }}</dd>

          <dt>
            {{
              i18n.t(
                '/Vcr/Contact Details/Customer Company/Chamber Of Commerce Establishment Label'
              )
            }}
          </dt>
          <dd>
            {{ customerCompany.CustomerCompanyChamberOfCommerceEstablishmentNumber }}
          </dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/Customer Company/Address Label') }}
          </dt>
          <dd>{{ customerCompany.CustomerCompanyAddress }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/Customer Company/Postal Code Label') }}
          </dt>
          <dd>{{ customerCompany.CustomerCompanyZipcode }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/Customer Company/City Label') }}
          </dt>
          <dd>{{ customerCompany.CustomerCompanyCity }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/Customer Company/Postal Address Label') }}
          </dt>
          <dd>{{ customerCompany.CustomerCompanyMailingAddress }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/Customer Company/Postal Address Complete Label') }}
          </dt>
          <dd>{{ customerCompany.CustomerCompanyMailingZipcodeAndCity }}</dd>

          <span class="vcr-quote-contact-details__section-subtitle">
            {{ i18n.t('/Vcr/Contact Details/Customer Company/Extra Info Title') }}
          </span>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/Customer Company/Invoice Name Label') }}
          </dt>
          <dd>{{ customerCompany.CustomerCompanyInvoiceName }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/Customer Company/Contact Person Label') }}
          </dt>
          <dd>{{ customerCompany.CustomerCompanyContact }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/Customer Company/Remarks Label') }}
          </dt>
          <dd>{{ customerCompany.CustomerCompanyInternalMessage }}</dd>
        </dl>
      </div>

      <div v-if="hasDealer" class="vcr-quote-contact-details__section">
        <h3 class="vcr-page__sub-header">
          {{ i18n.t('/Vcr/Contact Details/Dealer/Title') }}
        </h3>

        <dl>
          <dt>{{ i18n.t('/Vcr/Contact Details/Dealer/Name Label') }}</dt>
          <dd>{{ dealer.DealerName }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/Dealer/Email Address Label') }}
          </dt>
          <dd data-qa="vcr-dealer-email">{{ dealer.DealerEmail }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/Dealer/Phone Number Label') }}
          </dt>
          <dd>{{ dealer.DealerPhone }}</dd>

          <dt>{{ i18n.t('/Vcr/Contact Details/Dealer/Address Label') }}</dt>
          <dd>{{ dealer.DealerAddress }}</dd>

          <dt>{{ i18n.t('/Vcr/Contact Details/Dealer/Postal Code Label') }}</dt>
          <dd>{{ dealer.DealerZipCode }}</dd>

          <dt>{{ i18n.t('/Vcr/Contact Details/Dealer/City Label') }}</dt>
          <dd>{{ dealer.DealerCity }}</dd>
        </dl>
      </div>

      <div v-if="leaseCompany" class="vcr-quote-contact-details__section">
        <h3 class="vcr-page__sub-header">
          {{ i18n.t('/Vcr/Contact Details/LeaseCompany/Title') }}
        </h3>

        <dl>
          <dt>{{ i18n.t('/Vcr/Contact Details/LeaseCompany/Name Label') }}</dt>
          <dd>{{ leaseCompany.Name }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/LeaseCompany/Address Label') }}
          </dt>
          <dd>{{ leaseCompany.Address }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/LeaseCompany/Postal Code Label') }}
          </dt>
          <dd>{{ leaseCompany.ZipCode }}</dd>

          <dt>{{ i18n.t('/Vcr/Contact Details/LeaseCompany/City Label') }}</dt>
          <dd>{{ leaseCompany.City }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/LeaseCompany/Email Address Label') }}
          </dt>
          <dd>{{ leaseCompany.MailAddress }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/LeaseCompany/Debtor Label') }}
          </dt>
          <dd>{{ leaseCompany.DebtorId }}</dd>

          <dt>{{ i18n.t('/Vcr/Contact Details/LeaseCompany/Crm Label') }}</dt>
          <dd>{{ leaseCompany.CrmNumber }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/LeaseCompany/Customer Label') }}
          </dt>
          <dd>{{ leaseCompany.CustomerCompanyId }}</dd>
        </dl>
      </div>

      <div
        v-if="fleetContract && fleetContract.CustomerFleetCompany"
        class="vcr-quote-contact-details__section"
      >
        <h3 class="vcr-page__sub-header">
          {{ i18n.t('/Vcr/Contact Details/FleetCompany/Title') }}
        </h3>

        <dl>
          <dt>{{ i18n.t('/Vcr/Contact Details/FleetCompany/Name Label') }}</dt>
          <dd>{{ fleetContract.CustomerFleetCompany.BusinessName }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/FleetCompany/Customer Id Label') }}
          </dt>
          <dd>{{ fleetContract.CustomerFleetCompany.CustomerId }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/FleetCompany/Address Label') }}
          </dt>
          <dd>{{ fleetContract.CustomerFleetCompany.Street }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/FleetCompany/Postal Code City Label') }}
          </dt>
          <dd>
            {{ fleetContract.CustomerFleetCompany.ZipCode }}
            {{ fleetContract.CustomerFleetCompany.City }}
          </dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/FleetCompany/Phone Number Label') }}
          </dt>
          <dd>{{ fleetContract.CustomerFleetCompany.Phone }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/FleetCompany/Contract Number Label') }}
          </dt>
          <dd>{{ fleetContract.ContractNumber }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/FleetCompany/Deal Type Label') }}
          </dt>
          <dd>{{ fleetContract.KindOfDeal }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/FleetCompany/Discount Structure Label') }}
          </dt>
          <dd>{{ fleetContract.DiscountStructure }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/FleetCompany/Payment Type Label') }}
          </dt>
          <dd>{{ fleetContract.CustomerRebateSettlement }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/FleetCompany/Discount Label') }}
          </dt>
          <dd>{{ fleetContract.DiscountPercentage }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/FleetCompany/Final Ascription Date Label') }}
          </dt>
          <dd>{{ fleetContract.FinalAscriptionDate }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/FleetCompany/Mandatory Options Label') }}
          </dt>
          <dd>{{ fleetContract.MandatoryOptions }}</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/FleetCompany/Match Contract Label') }}
          </dt>
          <dd>{{ fleetContract.MatchPercentage || '-' }}%</dd>

          <dt>
            {{ i18n.t('/Vcr/Contact Details/FleetCompany/Remarks Label') }}
          </dt>
          <dd>{{ fleetContract.Remarks }}</dd>
        </dl>
      </div>
    </div>
    <div v-if="hasCustomerType" class="vcr-quote-contact-details__section customer-type">
      <dl>
        <dt>
          {{ i18n.t('/Vcr/Contact Details/Customer/Customer Type Label') }}
        </dt>
        <dd>{{ quoteCustomerType.GroupName }} - {{ quoteCustomerType.Name }}</dd>
      </dl>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    ...mapGetters({
      quote: 'quote/get',
      quoteCustomer: 'quote/customer',
      quoteCustomerCompany: 'quote/customerCompany',
      quoteCustomerType: 'quote/customerType',
      hasCustomerType: 'quote/hasCustomerType',
      hasCustomer: 'quote/hasCustomer',
      hasCustomerCompany: 'quote/hasCustomerCompany',
      leaseCompany: 'quote/leaseCompany',
      fleetContract: 'quote/fleetContract',
    }),
    customer() {
      return this.quoteCustomer || {}
    },
    customerCompany() {
      return this.quoteCustomerCompany || {}
    },
    employee() {
      return this.quote?.QuoteDetails?.Employee || {}
    },
    hasEmployee() {
      return this.employee && this.employee !== {}
    },
    dealer() {
      return this.quote?.QuoteDetails?.Dealer || {}
    },
    hasDealer() {
      return this.dealer && this.dealer !== {}
    },
  },
}
</script>

<style lang="scss" scoped>
.vcr-quote-contact-details {
  &__sections {
    display: flex;
    flex-wrap: wrap;
  }

  &__section {
    flex-basis: 50%;

    dl {
      display: flex;
      flex-wrap: wrap;

      > dt,
      > dd {
        flex: 0 0 50%;
      }
    }

    &-subtitle {
      font-weight: bold;
      flex-basis: 100%;
    }

    &.customer-type {
      width: 50%;
      margin-top: 1.4em;
    }
  }
}
</style>
